module.exports = __webpack_public_path__ + "static/header-placeholder-a9f4355a9216d444716f595778ff9b3f.jpg";